import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import AddConfigModal from '../components/addConfigModal'

export default function SpaceSpecsStep1 ({
  listRef = {},
  specsArgList = [],
  specsArgMap = {},
  spaceList = [],
  tableData = [],
  setTableData = (a) => ({})
})  {
  const [openConfigModal, setOpenConfigModal] = useState(false)
  const [editId, setEditId] = useState('');
  const [editData, setEditData] = useState({});

  useEffect(() => {

  }, []);

  const config = {
    rowSelection: false,
    columns: [
      {
        title: '空间标签',
        key: 'spaceName',
        dataIndex: 'spaceName',
        width: 200,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: '空间规格参数',
        key: 'spaceSpecParamName',
        dataIndex: 'spaceSpecParamName',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '包含规格值',
        key: 'includeValues',
        dataIndex: 'includeValues',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
        render: (records) => (
          <span>{ records?.map(item => item.argValue).join('，') }</span>
        )
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 120,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    footer: [
      {
        label: '添加配置',
        // auth: 'priceButton1',
        // type: 'primary',
        events: ['onClick:onAdd'],
      },
    ],
  }

  const confirmSpaceSpecs = (value: any) => {
    console.log(value)
    const list = value?.spaces?.map((space, index) => {
      const spaceName = spaceList.filter((item: any) => item.code === space)?.[0]?.name;
      const includeValues = specsArgMap?.[value?.spaceSpecParamId]?.filter((item: any) => value?.includeValueIds?.includes(item.id));
      const spaceSpecParamName = specsArgList?.filter((item: any) => item.id === value?.spaceSpecParamId)?.[0]?.argName;
      return {
        ...value,
        spaceCode: space,
        spaceName,
        includeValues,
        spaceSpecParamName,
      }
    }) || [];
    const filterTableData = tableData?.filter((data: any) => !value?.spaces?.includes(data.spaceCode)) || [];
    const newTableData = [...filterTableData, ...list];
    setTableData(newTableData);
    listRef.current?.updateDataSource(newTableData, newTableData?.length);
    setOpenConfigModal(false);
  }

  const editSpaceSpecs = (value: any, id) => {
    const newTableData = tableData?.map((data: any) => {
      if (data.spaceCode === id) {
        const includeValues = specsArgMap?.[value?.spaceSpecParamId]?.filter((item: any) => value?.includeValueIds?.includes(item.id));
        const spaceSpecParamName = specsArgList?.filter((item: any) => item.id === value?.spaceSpecParamId)?.[0]?.argName;
        return {
          ...data,
          ...value,
          includeValues,
          spaceSpecParamName,
        }
      }
      return {
        ...data,
      }
    }) || [];
    setTableData(newTableData);
    listRef.current?.updateDataSource(newTableData, newTableData?.length);
    setOpenConfigModal(false);
  }

  const fetchList = async values => {

  }

  const onAdd = () => {
    setEditId('');
    setOpenConfigModal(true);
  }

  const onEdit = (record: any = {}) => {
    setEditId(record?.spaceCode);
    setEditData(record);
    setOpenConfigModal(true);
  }

  const onDelete = async (record: any) => {
    const newTableData = tableData?.filter((data: any) => data.spaceCode !== record.spaceCode);
    setTableData(newTableData);
    listRef.current?.updateDataSource(newTableData, newTableData?.length);
  }

  // 表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd, onEdit },
    status: {
      // selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      // radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              编辑
            </SActionBtn>
            <SActionBtn style={{ color: 'red' }} onClick={() => onDelete(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      {/* 右侧数据表格 */}
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      {
        openConfigModal &&
          <AddConfigModal
            editId={editId}
            editData={editData}
            openModal={openConfigModal}
            setOpenModal={setOpenConfigModal}
            specsArgList={specsArgList}
            specsArgMap={specsArgMap}
            spaceList={spaceList}
            confirm={confirmSpaceSpecs}
            editSpaceSpecs={editSpaceSpecs}
          />
      }
    </div>
  )
}